<template>
  <div id="app" style="min-width:1020px;">    
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>


// WEBPACK FOOTER //
// src/App.vue